import { useTelegram } from "@/shared/hooks/useTelegram";
import { useEffect } from "react";

export const TelegramProvider = ({ children }: { children: React.ReactNode }) => {
    const { telegramWebApp } = useTelegram();

    useEffect(() => {
        telegramWebApp.ready();
        telegramWebApp.expand();
        return () => {};
    }, [telegramWebApp]);

    return <>{children}</>;
};
